// Sample usage:
//     <Modal isOpen={isModalOpen} onClose={() => setModalOpen(false)}>
//     <h2>What's the name of the Patient?</h2>
//     <EditableLabel text="" onChange={setGroup} />
//     </Modal>

import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { isCX } from 'api/DeviceInfo';

const Modal = ({
  isOpen,
  onClose,
  children,
  buttons,
  fullScreen = false,
  isCloseButton = true,
  onEnterClose = false,
  hideCross = false,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (onEnterClose && e.key === 'Enter') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onEnterClose, onClose]);

  if (!isOpen) return null;

  const handleButtonClick = async (onClickHandler) => {
    await onClickHandler(); // Wait for the action to complete
    onClose(); // Close the modal after handling the button click
  };

  const modalContent = (
    <div
      className="modal-overlay"
      style={fullScreen ? overlayStyle : null}
      onClick={(e) => {
        if (e.target.className === 'modal-overlay') {
          onClose();
        }
      }}
    >      <div
      className="modal-content"
      style={fullScreen ? modalContentStyle : null}
    >
        <div
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            cursor: 'pointer',
            fontSize: '1.5rem',
            color: '#000', // Adjust color as needed
          }}
        >
          {hideCross ? null : <i className="fa fa-times" aria-hidden="true"></i>}
        </div>

        {children}
        {buttons && buttons.length > 0 ? (
          <div className="modal-buttons">
            {buttons.map((button, index) => (
              <Button
                key={index}
                color={button.color}
                onClick={() => handleButtonClick(button.onClick)}
                style={
                  button.color === 'grey' ? { border: '1px solid grey' } : {}
                }
                disabled={button.disabled || false}
              >
                {button.label}
              </Button>
            ))}
          </div>
        ) : isCloseButton ? (
          <Button color="secondary" onClick={onClose}>
            Close
          </Button>
        ) : null}
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body); // this makes sure that modal is over all the components
};

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0, 0, 0, 0.7)', // Optional: for dimming the background
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 100000,
};

const modalContentStyle = {
  position: 'relative',
  backgroundColor: 'white',
  width: '90%',
  height: '90%',
  maxWidth: 'none',
  maxHeight: 'none',
  padding: 0,
  borderRadius: 0,
};

export default Modal;
